import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import CommonForm from "./CommonForm";
import ListComponent from "./ListComponent";
// 
export default function StaffUser(props) {
  return (
    <>
    {/* {alert("rr")} */}
      <div className="flex-row-fluid" {...props}>
        <Switch>
          <Redirect
            from="/apkscreen"
            exact={true}
            to="/apkscreen/list"
          />
          <Route
            path="/apkscreen/list"
            component={ListComponent}
          />
          <Route
            path="/apkscreen/create"   
            component={CommonForm}
          />
          <Route
            path="/apkscreen/edit/:id"
            component={CommonForm}
          />
        </Switch>
      </div>
    </>
  );
}
